import {RoleModels, AuthConfigReducer} from '@pwbapps/reduxcore'
import _ from 'lodash';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp } from '../../utils/costants';
import { getSelectedProjectName } from './project';

export const getSelectedProjectUserRole = (state: any): RoleModels.Role | undefined => {
    const projectName = getSelectedProjectName(state);
    const roles = AuthConfigReducer.getRoles(state);
    const superAdmin = _.find(roles, r => r.name === 'SUPERADMIN');
    return  (roles && roles.length > 0) ? (superAdmin ? superAdmin : ((projectName) ? _.find(roles, r => r.name.includes(_.replace(projectName, /\s/g, ''))) : undefined)) : undefined;  
}

export const getSelectedProjectUserActions = (state: any): InternalRoleActionsType[] | ExternalRoleActionsType[] => {
    const userProjectRole = getSelectedProjectUserRole(state);
    if(userProjectRole)
        return (!isExternalApp) ? userProjectRole.actions as InternalRoleActionsType[] : userProjectRole.actions as ExternalRoleActionsType[];
    return [];
}